import React from "react";
import ReactDOM from "react-dom";
import UIKit from "./app/UIKit.jsx";

import css from './css/app.scss';


const container = document.getElementById("ui-container");
if (container)
ReactDOM.render(
  <UIKit/>,
  container
);



// WEBPACK FOOTER //
// ./ui.jsx